export const HOTEL_CARD_TEST_ID = 'hotel-card';

export const HOTEL_CARD_TITLE = 'hotel-card__title';

export const HOTEL_CARD_EXPLORE_BUTTON = 'hotel-card__explore-btn';

export const HOTEL_CARD_HOTEL_INFO = 'hotel-card__hotel-info';

export const HOTEL_CARD_CLOSE_ICON = 'hotel-card___close-icon';
